import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import { SiteContentProvider } from './context/SiteContentContext';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Membership from './pages/Membership';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import HowWeHelp from './pages/HowWeHelp';
import Events from './pages/Events';
import KnowledgeHub from './pages/KnowledgeHub';
import ArticleDetail from './pages/ArticleDetail';
import CorporateLifeSeries from './pages/CorporateLifeSeries';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/admin/Dashboard';
import MemberDashboard from './pages/member/Dashboard';
import './App.css';

const withLayout = (Page) => (
  <>
    <Navbar />
    <Page />
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <SiteContentProvider>
      <div className="App min-h-screen flex flex-col">
        <Routes>
          <Route path="/" element={withLayout(Home)} />
          <Route path="/about" element={withLayout(About)} />
          <Route path="/how-we-help" element={withLayout(HowWeHelp)} />
          <Route path="/events" element={withLayout(Events)} />
          <Route path="/services" element={withLayout(Services)} />
          <Route path="/membership" element={withLayout(Membership)} />
          <Route path="/join" element={withLayout(Membership)} />
          <Route path="/volunteer" element={withLayout(Membership)} />
          <Route path="/knowledge-hub" element={withLayout(KnowledgeHub)} />
          <Route path="/knowledge-hub/:id" element={withLayout(ArticleDetail)} />
          <Route path="/corporate-life-series" element={withLayout(CorporateLifeSeries)} />
          <Route path="/contact" element={withLayout(Contact)} />
          <Route path="/donate" element={withLayout(Donate)} />

          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/member/dashboard" element={<MemberDashboard />} />
        </Routes>
        <Toaster />
      </div>
      </SiteContentProvider>
    </BrowserRouter>
  );
}

export default App;
